const API_KEY = "bdffd76d95da4a6ab8ac10d44f8d6a3f";
const ACCESS_TOKEN = "YOUR_ACCESS_TOKEN";
const BASE_URL = "https://stock.adobe.io/Rest/Media/1/Search/Files";
const APP_URL = "https://images.okepas.com";
const galleryContainer = document.getElementById("galleryContainer");
const loader = document.querySelector(".loading-images");
const itemsPerPage = 18;
let currentPage = 1;
let totalItems = 0;
let filteredImages = [];

document.getElementById("searchBtn").addEventListener("click", function () {
  const query = document.getElementById("searchInput").value.trim();
  if (!query) {
    alert("Please enter a search term.");
    return;
  }

  loader.style.display = "block";
  currentPage = 1;
  const finalQuery = `${query}`;

  fetchImages(finalQuery);
});

galleryContainer.addEventListener("click", async function (event) {
  if (event.target && event.target.matches(".add-button")) {
    const dataId = event.target.getAttribute("data-id");
    console.log("Data ID:", dataId);
    try {
      const button = event.target;
      const loader = button.nextElementSibling;
      loader.style.display = "block";
      const response = await fetch(`https://images.okepas.com/download`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ assetId: dataId }),
      });

      if (!response.ok) {
        loader.style.display = "none";
        throw new Error(
          `Failed to send data to the API. Status: ${response.status}`
        );
      }

      const data = await response.json();

      if (data.status) {
        loader.style.display = "none";

        const countryMap = {
          CA: "ca",
          EU: "eu",
          AT: "eu",
          AU: "au",
        };

        let country = countryMap[Shopify.country] || "eu";

        const url = `https://okepas.com/en-${country}/products/okepas-custom-sneaker?pattern=${data.filePath}`;
        window.open(url, "_blank");
      }

      if (!data.status) {
        loader.style.display = "none";
        alert(data.message);
      }
    } catch (error) {
      loader.style.display = "none";
      console.error("Error:", error);
    }
  }

});

function fetchImages(query = null) {

  let queryParams = `?search_parameters[filters][content_type:photo]=1`;
  queryParams += `&search_parameters[filters][use]=commercial`;
  queryParams += `&search_parameters[filters][orientation]=horizontal`;
  queryParams += `&search_parameters[limit]=${itemsPerPage}`;
  queryParams += `&search_parameters[offset]=${
    (currentPage - 1) * itemsPerPage
  }`;

  if (query) {
    queryParams += `&search_parameters[words]=${encodeURIComponent(
      query
    )} pattern`;
  } else {
    queryParams += `&search_parameters[words]= graffiti pattern`;
    $("#searchInput").val("graffiti");
  }

  const url = `${BASE_URL}${queryParams}`;

  const loader = document.querySelector(".loading-images");
  loader.style.display = "block";

  fetch(url, {
    method: "GET",
    headers: {
      "X-Api-Key": API_KEY,
      "X-Product": "Your_Product_Identifier",
      Accept: "application/json",
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
      return response.json();
    })
    .then((data) => {
      loader.style.display = "none";

      totalItems = data.nb_results || 0;
      const filteredImages = data.files || [];

      populateGallery(filteredImages);
      updatePagination();
    })
    .catch((error) => {
      loader.style.display = "none";
      console.error("Error fetching images:", error);
    });
}

async function populateGallery(images) {
  const isCustomerLoggedIn = ShopifyAnalytics.meta?.page?.customerId;
  let mostLovedImageIds = []; 
  let discardedImageIds = [];
  var discardedResult = await getDiscarded();
  console.log({discardedResult});
  discardedImageIds = discardedResult.data.map((discarded) => discarded.image_id);
  if (isCustomerLoggedIn) {
    const mostLovedImages = await getMostLoved();
    mostLovedImageIds = mostLovedImages.data.map(loved => String(loved.image_id));
  }
  galleryContainer.innerHTML = "";

  if (images.length === 0) {
    galleryContainer.innerHTML =
      "<p>No images found. Try another search term.</p>";
    return;
  }

  images.forEach((image) => {
    const isLoved = mostLovedImageIds.includes(String(image.id));
    const isDiscarded = discardedImageIds.includes(String(image.id));
    if(!isDiscarded){
      const imgElement = document.createElement("span");
      imgElement.className = "gallery-item image-container";
      imgElement.innerHTML = `<button class="hide-btn-icon" title="Hide Image">&#10006;</button>
        <input type="checkbox" 
            class="image-checkbox${isLoved ? ' most-loved-saved' : ''}" 
            value="${image.id}" 
            ${isLoved ? "checked" : ""} />
        <img src="${image.thumbnail_url}" alt="${image.title}" />
        <button class="add-button" data-id="${image.id}">Add</button>
        <div class="loader" style="display: none;"></div>
      `;
      const hideBtn = imgElement.querySelector('.hide-btn-icon');
      hideBtn.addEventListener('click', () => {
        const modal = document.getElementById("hideModal");
        const submitBtn = document.getElementById("submitHide");
        const cancelBtn = document.getElementById("cancelHide");
        const commentInput = document.getElementById("hideComment");

        modal.style.display = "flex";
        commentInput.value = ""; // reset field

        // Remove old event listeners if any
        const newSubmitBtn = submitBtn.cloneNode(true);
        submitBtn.parentNode.replaceChild(newSubmitBtn, submitBtn);

        newSubmitBtn.addEventListener("click", () => {
          const comment = commentInput.value.trim();
          if (!comment) {
            alert("Please enter a comment.");
            return;
          }
          var endpoint = APP_URL+"/api/discarded/add"

          // ✅ Send AJAX request
          fetch(endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              image_id: image.id,
              reason: comment,
              image_src: image.thumbnail_url
            }),
          })
          .then(response => response.json())
          .then(data => {
            // Optional: show success message
            imgElement.remove(); // remove the image
            modal.style.display = "none";
          })
          .catch(error => {
            console.error("Error hiding image:", error);
            alert("Failed to submit.");
          });
        });

        cancelBtn.onclick = () => {
          modal.style.display = "none";
        };
      });
      galleryContainer.appendChild(imgElement);
    }
  });
  attachCheckboxListeners();
}

async function getMostLoved() {
  try {
    const response = await fetch(`${APP_URL}/api/most-loved`);
    console.log({response});
    if (!response.ok) throw new Error("Failed to fetch most loved images");
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching favourites:", error);
    return [];
  }
}

async function getDiscarded() {
  try {
    const response = await fetch(
      `${APP_URL}/api/discarded`
    );
    if (!response.ok) throw new Error("Failed to fetch discarded");

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching discarded:", error);
    return [];
  }
}


function updatePagination() {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const paginationContainer = document.getElementById("pagination");
  paginationContainer.innerHTML = "";

  // Create Previous button
  const prevButton = document.createElement("button");
  prevButton.textContent = "Previous";
  prevButton.disabled = currentPage === 1;
  prevButton.addEventListener("click", function () {
    if (currentPage > 1) {
      currentPage--;
      fetchImages(document.getElementById("searchInput").value.trim());
    }
  });
  paginationContainer.appendChild(prevButton);

  const pageLimit = 7;
  const ellipsis = document.createElement("span");
  ellipsis.textContent = "...";

  if (totalPages <= pageLimit) {
    for (let i = 1; i <= totalPages; i++) {
      createPageButton(i, paginationContainer);
    }
  } else {
    createPageButton(1, paginationContainer);

    if (currentPage > 4) {
      paginationContainer.appendChild(ellipsis);
    }

    const startPage = Math.max(2, currentPage - 1);
    const endPage = Math.min(totalPages - 1, currentPage + 1);

    for (let i = startPage; i <= endPage; i++) {
      createPageButton(i, paginationContainer);
    }

    if (currentPage < totalPages - 3) {
      paginationContainer.appendChild(ellipsis);
    }

    createPageButton(totalPages, paginationContainer);
  }

  const nextButton = document.createElement("button");
  nextButton.textContent = "Next";
  nextButton.disabled = currentPage === totalPages;
  nextButton.addEventListener("click", function () {
    if (currentPage < totalPages) {
      currentPage++;
      fetchImages(document.getElementById("searchInput").value.trim());
    }
  });
  paginationContainer.appendChild(nextButton);
}

function createPageButton(pageNumber, container) {
  const pageButton = document.createElement("button");
  pageButton.textContent = pageNumber;
  pageButton.className = pageNumber === currentPage ? "active" : "";
  pageButton.addEventListener("click", function () {
    currentPage = pageNumber;
    fetchImages(document.getElementById("searchInput").value.trim());
  });
  container.appendChild(pageButton);
}

document.getElementById("prevPage").addEventListener("click", function () {
  if (currentPage > 1) {
    currentPage--;
    fetchImages(document.getElementById("searchInput").value.trim());
  }
});

document.getElementById("nextPage").addEventListener("click", function () {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  if (currentPage < totalPages) {
    currentPage++;
    fetchImages(document.getElementById("searchInput").value.trim());
  }
});

const urlParams = new URLSearchParams(window.location.search);
const searchParam = urlParams.get("search"); // Get 'search' parameter from URL

if (searchParam) {
  document.getElementById("searchInput").value = searchParam;
  const finalQuery = `${searchParam}`;

  fetchImages(finalQuery);
}

fetchImages();

function attachCheckboxListeners() {
  const checkboxes = document.querySelectorAll(".image-checkbox");
  const button = document.getElementById("addToMostLoved");

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", () => {
      const anyChecked = [...checkboxes].some((cb) => cb.checked && !cb.classList.contains("most-loved-saved"));
      button.style.display = anyChecked ? "inline-block" : "none";

      // If checkbox was previously saved and is now unchecked — send delete
      if (!checkbox.checked && checkbox.classList.contains("most-loved-saved")) {
        const imageId = checkbox.value;

        if (imageId) {
          const deleteUrl = `${APP_URL}/api/most-loved/delete/${imageId}`;
          fetch(deleteUrl, {
            method: "GET"
          })
            .then(res => res.json())
            .then(data => {
              if (data.status) {
                 alert("Imaged removed from most loved");
                console.log(`Removed image ${imageId} from Most Loved`);
                checkbox.classList.remove("most-loved-saved");
              } else {
                console.error("Failed to remove:", data.message);
              }
            })
            .catch(err => {
              console.error("Error removing image:", err);
            });
        }
      }
    });
  });

  button.onclick = async () => {
    const selectedData = [...checkboxes]
      .filter((cb) => cb.checked)
      .map((cb) => {
        const img = cb.nextElementSibling;
        return {
          image_id: cb.value,
          image_src: img ? img.src : ""
        };
      });

    if (selectedData.length === 0) return;

    const url = `${APP_URL}/api/most-loved/add`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ images: selectedData })
      });

      const result = await response.json();

      if (response.ok) {
        alert("Successfully added to Most Loved!");

        // Mark checkboxes as saved
        [...checkboxes].forEach(cb => {
          if (cb.checked) cb.classList.add("most-loved-saved");
        });

        // Optionally hide the button
        button.style.display = "none";
      } else {
        console.error("Failed to add:", result.message || result);
        alert("Failed to add. Please try again.");
      }
    } catch (error) {
      console.error("Error during request:", error);
      alert("Something went wrong.");
    }
  };

  $('#hideComment').on('paste', function (e) {
    const pastedData = (e.originalEvent || e).clipboardData.getData('text');
    const currentLength = $(this).val().length;

    if ((currentLength + pastedData.length) > 500) {
      e.preventDefault();
      $('#reasonError').show();
    }
  });

  $('#hideComment').on('input', function () {
    const maxLength = 500;
    const currentLength = $(this).val().length;

    if (currentLength >= maxLength) {
      $('#reasonError').show();
    } else {
      $('#reasonError').hide();
    }
  });
}


